<template>
	<div class="pass-layout">
		<img class="pass-bg-img"
			src="@/assets/img/top_bg.png" alt="">
		<div class="pass-title text_c font_weight font_s24 p-30 main_color">知识宝典</div>
		<!-- 移动端顶部Tab导航 -->
		<div class="mobile-nav">
			<div class="mobile-nav-inner">
				<div
					v-for="item in menuItems"
					:key="item.index"
					class="mobile-nav-item"
					:class="{ active: activeMenu === item.index }"
					@click="handleMenuSelect(item.index)">
					<i :class="item.icon"></i>
					<span>{{ item.label }}</span>
				</div>
			</div>
		</div>
		<div class="main_w mar_auto pass-container">
			<!-- PC端左侧菜单 -->
			<div class="pass-sidebar">
				<el-menu
					:default-active="activeMenu"
					class="pass-menu"
					@select="handleMenuSelect"
					:collapse="false"
					:router="false">
					<el-menu-item index="/pass">
						<i class="el-icon-s-home"></i>
						<span>宝典首页</span>
					</el-menu-item>
					<el-menu-item index="/pass/records">
						<i class="el-icon-document"></i>
						<span>答题记录</span>
					</el-menu-item>

				</el-menu>
			</div>
			<div class="pass-content">
				<keep-alive>
					<router-view></router-view>
				</keep-alive>
			</div>
		</div>
		<br><br>
	</div>
</template>
<script>
export default {
	name: "PassLayout",
	data() {
		return {
			menuItems: [
					{ index: '/pass', icon: 'el-icon-s-home', label: '首页' },
					{ index: '/pass/records', icon: 'el-icon-document', label: '答题记录' },
				]
		};
	},
	computed: {
		activeMenu() {
			const path = this.$route.path;
			if (path === '/pass' || path === '/pass/papers') {
				return '/pass';
			}
			return path;
		}
	},
	methods: {
		handleMenuSelect(index) {
			if (this.$route.path !== index) {
				this.$router.push(index);
			}
		}
	}
};
</script>
<style scoped>
.pass-layout {
	position: relative;
}
.pass-bg-img {
	height: 706px;
	position: absolute;
	top: -40px;
	z-index: -1;
	left: 0;
	right: 0;
	width: 100%;
}
.pass-container {
	display: flex;
	gap: 20px;
	min-height: 500px;
}
.pass-sidebar {
	width: 220px;
	flex-shrink: 0;
}
.pass-menu {
	border-radius: 8px;
	overflow: hidden;
	border-right: none !important;
	box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
	background: #fff;
}
.pass-menu .el-menu-item {
	height: 56px;
	line-height: 56px;
	font-size: 15px;
	padding: 0 20px !important;
	overflow: visible !important;
	text-overflow: unset !important;
	white-space: nowrap !important;
}
.pass-menu .el-menu-item i {
	font-size: 18px;
	margin-right: 8px;
}
.pass-menu .el-menu-item.is-active {
	background-color: #ecf5ff !important;
	color: #163F88;
	font-weight: bold;
	border-right: 3px solid #163F88;
}
.pass-menu .el-menu-item:hover {
	background-color: #f5f7fa !important;
}
.pass-content {
	flex: 1;
	min-width: 0;
}

/* 移动端顶部Tab导航 - 默认隐藏 */
.mobile-nav {
	display: none;
}

/* 移动端自适应 */
@media screen and (max-width: 768px) {
	.pass-bg-img {
		height: 300px;
		top: -20px;
	}
	.pass-title {
		font-size: 18px !important;
		padding: 15px !important;
	}
	/* 隐藏PC端左侧菜单 */
	.pass-sidebar {
		display: none;
	}
	/* 显示移动端顶部Tab导航 */
	.mobile-nav {
		display: block;
		padding: 0 15px;
		margin-bottom: 15px;
	}
	.mobile-nav-inner {
		display: flex;
		background: #fff;
		border-radius: 8px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
		overflow: hidden;
	}
	.mobile-nav-item {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 12px 4px;
		font-size: 12px;
		color: #666;
		cursor: pointer;
		transition: all 0.3s;
		border-bottom: 2px solid transparent;
	}
	.mobile-nav-item i {
		font-size: 18px;
		margin-bottom: 4px;
	}
	.mobile-nav-item.active {
		color: #163F88;
		font-weight: bold;
		background-color: #ecf5ff;
		border-bottom-color: #163F88;
	}
	.mobile-nav-item:active {
		background-color: #f5f7fa;
	}
	/* 容器自适应 */
	.pass-container {
		flex-direction: column;
		padding: 0 15px;
		min-height: auto;
		gap: 0;
	}
	.pass-content {
		width: 100%;
	}
}
</style>
